import { ucFirst } from './formatString';
import { formatDate } from './formatDate';
import { translate } from './translate';

export const formatContractPaymentOptions = (options, literals) => {
  let months = 0;
  return (options || []).map((option, index) => {
    const empaqueFromApi = option.Empaque != null
      ? String(option.Empaque).trim()
      : '';
    const obj = {
      key: `${option.ClavePago}-${index}`,
      title: '',
      description: '',
      amount: option.Monto,
      min: option.PagoMinimo,
      max: option.PagoMaximo,
      limitDate: formatDate(option.FechaLimitePago, 'DD/MM/YYYY'),
      limitDateTime: new Date(option.FechaLimitePago).getTime(),
      fechaResultante: option.FechaResultante
        ? formatDate(option.FechaResultante, 'DD/MM/YYYY')
        : null,
      paymentKey: option.ClavePago,
      ClavePago: option.ClavePago,
      Empaque: empaqueFromApi || undefined,
    };

    const optionTitle = literals.paymenOptionsTitle[option.ClavePago];
    const optionDescription = literals.paymenOptionsDescription[option.ClavePago];

    obj.description = '';
    if (!optionTitle) {
      obj.title = ucFirst(option.DescripcionPago);
    } else {
      if (optionTitle.includes('{months}') || optionDescription.includes('{months}')) {
        months += 1;
        obj.months = months;
      }
      obj.title = translate(optionTitle, {
        months, monthsLiteral: months === 1 ? literals.common.month : literals.common.months,
      });
      if (optionDescription) {
        obj.description = translate(optionDescription, {
          months, monthsLiteral: months === 1 ? literals.common.month : literals.common.months,
        });
      }
    }
    return obj;
  }) || [];
};
